import Api from "~/service/Api";

class OtherProductRepository {
  fetch(query = {}) {
    return Api.get("/other-products", query);
  }

  getOne(otherProductId, query) {
    return Api.get(`/other-products/${otherProductId}`, query);
  }
}

export default OtherProductRepository;
